import { NestedHome } from "@habity/types";
import { CommonEstateBid } from "@habity/types/vitec/common/commonEstateBid";
import { formatCurrency } from "@habity/utils";
import { getHighestBid } from "./bids";

/**
 * Check if price should be shown for a home.
 * Considers both status.show_price and home.hide_price column
 */
export const shouldShowPrice = (home: NestedHome | null): boolean => {
  if (!home) return false;
  const { status, is_price_hidden } = home;
  if (!status?.show_price) return false;
  if (is_price_hidden === true) return false;
  return true;
};

export const getPricePerSquareMeter = (home: NestedHome) => {
  const price = getPriceValue(home);
  const { address } = home || {};
  const { living_space } = address || {};
  if (price && living_space) {
    const pricePerSquareMeter = Math.round(price / living_space);
    return formatCurrency(pricePerSquareMeter);
  }
  return "";
};

export const getPriceValue = (home: NestedHome | null, includeBids = false) => {
  const { price } = home || {};
  // // Without a broker, sellers are only allowed to estimate the price
  // if (provider !== "vitec")
  //   return estimate ? Math.round(estimate / 10000) * 10000 : 0;
  // Otherwise check for bids and fallback to price
  if (includeBids) {
    const highestBid = getHighestBid(home);
    if (highestBid > 0) return highestBid;
  }
  return price;
};

export const getPrice = (home: NestedHome | null, includeBids = false) => {
  const value = getPriceValue(home, includeBids);
  if (!value) return "Inget utropspris";
  return formatCurrency(value);
};
